const data = [
  {
    title: 'Senior Software Engineer',
    from: '05/2020',
    to: '10/2022',
    employer: {
      name: 'Samarkand',
      location: 'London',
      description: 'Ecommerce into China SaaS Platform',
    },
    keySkills: [
      'JS',
      'Kubernetes',
      'Gitlab CI',
      'Cypress',
      'react',
      'nextjs',
      'GraphQL',
      'Mongo',
      'Cockroach',
    ],
    skills: [
      'bash',
      'kubernetes',
      'helm',
      'docker',
      'docker-compose',
      'kaniko',
      'Harbor Container Hosting',
      'Trivy Container Scanning',
      'SAST',
      'vault',
      'prometheus',
      'Grafana',
      'Jaeger',
      'Loki',
      'Tempo',
      'Linkerd',
      'Gitlab',
      'Gitlab CI',
      'Renovate',
      'kind',
      'tilt',
      'Skaffold',

      'nginx',
      'apache',
      'PHP',
      'typescript',
      'javascript',
      'html',
      'css',

      'artillery',
      'predator',
      'k6',

      'Backstage Platform',
      'Architecture Decision Records',
      'Incident Response/Management',

      'react',
      'nextjs',
      'styled-components',
      'AntDesign',
      'Storybook',
      'Cypress',

      'Cloudflare Workers',
      'GraphQL',
      'Express',
      'Kafka',
      'Apache Avro',
      'Mongo',
      'CockRoachDB',
      'Postgres',
      'KeyCloak',
    ],
    achievements: [
      'Talks/Workshops: Open Telemetry, GraphQL, Game Day',
      'Created Weekly Tech Talks Forum which inspired the creation of a company-wide forum',
      'Created Team Onboarding Process',
      'Created Incident Response Process',
      'Ran Weekly Architecture Meetings',
      "Architected our team's services including back office and ecommerce stores",
      'Build Full Continuous Delivery Pipeline including build, security, and progressive deployment to kubernetes',
    ],
  },
  {
    title: 'Product Engineer',
    from: '02/2018',
    to: '09/2018',
    employer: {
      name: 'Hubble',
      location: 'London',
      description: 'Prop Tech',
    },
    keySkills: [
      'microservices',
      'React',
      'Kafka',
      'Python',
      'Django',
      'Serverless',
    ],
    responsibilities: [
      'Scaling the platform to work internationally.',
      'Improving existing features and building new ones across our tenant platform (search, listings, static pages and more).',
      'Building out host tools to help customers manage their space efficiently (viewing management, messaging, payments, etc.).',
      'Migrating the codebase from AngularJS to React and CSS-in-JS.',
      'Make the work of the internal team via Automation (internal "Huuble" platform, CRM integrations, etc.).',
      'Adding to our newly built and ever-growing component library.',
    ],
    achievements: [
      'Ran Workshops: GraphQL, Jam Stack (Gatsby) and Value Stream Mapping',
      'Introduced Redux and Cypress Automated Testing',
      'Built new react based responsive sitewide navigation',
      'Built company CLI and docker based developer environment setup (1h setup; down from 1 week)',
      'Built lambda based pipelines for data scientist',
      'Upgraded Legacy Django Service',
      'Introduced Continuous Delivery and Kanban (pull, constraints, value stream mapping)',
    ],
  },
  {
    title: 'Technical Architect',
    from: '08/2016',
    to: '04/2017',
    employer: {
      name: 'Agency Mobile',
      location: 'London',
      description: 'Mobile/Web Development Agency',
    },
    keySkills: [
      'microservices',
      'AWS',
      'Kubernetes',
      'Serverless',
      'React',
      'Gatsby',
      'PHP',
    ],
    responsibilities: [
      'Meet clients, understand their needs and architect solutions accordingly.',
      'Build and look after cloud infrastructure in a resilient and cost effective manner.',
      'Build backend APIs to support web and mobile apps.',
      'Build React and React Native apps.',
      'Improve and maintain the company’s portfolio of applications.',
      'Recruit, coach and mentor developers.',
      'Design incident and disaster response processes and execute.',
    ],
    achievements: [
      'Fixed scaling issues for PHP/D3.js based dashboard for mobile manufacturer (avg response time decreased by 128x).',
      'Built a Docker, Kubernetes and Terraform platform to support a microservices, SPAs and traditional MVC/CMS workloads.',
      'Performed cloud migrations for a range of web applications.',
      'Led a team of 3 engineers.',
    ],
  },
  {
    title: 'Platform Engineer',
    from: '11/2015',
    to: '06/2016',
    employer: {
      name: 'MOO Print',
      location: 'London',
      description: 'Web Development Agency',
    },
    keySkills: [
      'ELK Stack',
      'Debian',
      'Jenkins',
      'Gitlab CI',
      'Selenium',
      'Java',
    ],
    responsibilities: [
      'Manage services such as Gitlab, Jenkins, Fisheye, Deployment Tools, Selenium Grid, Docker Registry, etc.',
      'Improve the way the development teams build, test, deploy and monitor software.',
    ],
    achievements: [
      'Introduced Continuous Delivery and Concourse CI to the wider team.',
      'Introduced containerisation and orchestration tools.',
      'Automated unit, functional and contract testing.',
      'Introduced application metrics stack using StatsD, InfluxDB and Grafana.',
      'Made release management and deployment accessible to the whole team through automation.',
    ],
  },
  {
    title: 'Senior Software Engineer',
    from: '08/2014',
    to: '12/2015',
    employer: {
      name: 'MOO Print',
      location: 'London',
      description: 'Web Development Agency',
    },
    keySkills: ['PHP', 'Symfony', 'Java', 'React', 'Jenkins', 'Selenium'],
    responsibilities: [
      'Develop the MBS platform and supporting its back-office functionality.',
      'Improve the quality, performance and security of the platform.',
      'Design the interfaces and protocols between client & server side components.',
      'Write automated tests at unit, integration and functional level.',
      'Mentor and support other engineers via pair programming, code walkthroughs and reviews.',
      'Maintain and develop the high standards of the team through process improvements or adherence to best practices.',
      'Share your expertise to improve MOO’s overall effectiveness.',
    ],
    achievements: [
      'Instrumental in migrating our cards design tool from Flash to React.',
      'Reduced regression testing from 3 days to 4 hours.',
      'Built Software Delivery Pipelines and introduced BDD and Example Mapping.',
      'Fixed crippling scaling and state mutation issues for large orders during checkout.',
      'Built ansible managed selenium grid infrastructure which is now used by all teams.',
    ],
  },
  {
    title: 'Senior/Lead Software Engineer',
    from: '04/2012',
    to: '06/2014',
    employer: {
      name: 'Vivo Rewards',
      location: 'London',
      description: 'Social Rewards Platform',
    },
    keySkills: ['PHP', 'MySQL', 'MySQL', 'Behat (BDD)'],
    responsibilities: [
      'Create test strategies and frameworks for all applications. Coach and mentor developer in how to use them.',
      'Build SOA architectures.',
      'Promote best practices in software development.',
    ],
    achievements: [
      'Led a multifunctional team of engineers.',
      'Reduced unit tests run time from 3 hours to just under 2 minutes whilst doubling the number of tests.',
      'Built Kafka based data pipeline for a gamification system designed to handle 2TB of events per day.',
      'Designed test strategies and frameworks for 4 applications including a mobile app.',
      'Increased code quality by introducing BDD and TDD and building associated tools and teaching resources.',
    ],
  },
  {
    title: 'Senior Software Developer',
    from: '05/2010',
    to: '03/2012',
    employer: {
      name: 'Telappliant',
      location: 'London',
      description: 'VoIP Communication Provider',
    },
    keySkills: ['PHP', 'MySQL', 'Linux'],
    responsibilities: [
      'Design and build new systems, web applications and web services from the ground up.',
      'Maintain and enhance high traffic web applications.',
      'Recruit and mentor junior developers.',
    ],
    achievements: [
      'Major speed improvements for API which gets called over 1M times a day.',
      'Built and maintained several Linux (Gentoo, CentOS) Servers.',
      'Led migration from OsCommerce to Magento.',
    ],
  },
  {
    title: 'Full Stack Developer',
    from: '08/2008',
    to: '03/2010',
    employer: {
      name: 'NetStim',
      location: 'Paris',
      description: 'Web Development Agency',
    },
    keySkills: ['PHP', 'MySQL', 'SQL Server', 'IIS', 'JS', 'HTML', 'CSS'],
    responsibilities: [
      'Design and build databases.',
      'Write SOLID Object Oriented and documented PHP, ASP and JavaScript code.',
      'Write cross browser and search engine friendly user interfaces based on wireframes and PSDs.',
    ],
    achievements: [
      'Built WebTV and heavily customised forum for French supermarket chain Truffaut.',
      'Created catalogue import system Truffaut that processed several TB of product/store data nightly.',
      'Built CMS for Camping provider Les Castels and infolunettes.com',
      'Optimised accommodation API for Les Castels increasing 95th percentile response times by 600%.',
      'Promoted to mid-weight after 6 months',
    ],
  },
]

export default data
